import { render } from "./TemplateUpdate.vue?vue&type=template&id=39217277&scoped=true&ts=true"
import script from "./TemplateUpdate.vue?vue&type=script&lang=ts"
export * from "./TemplateUpdate.vue?vue&type=script&lang=ts"

import "./TemplateUpdate.vue?vue&type=style&index=0&id=39217277&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39217277"]])

export default __exports__